<template>
	<main v-if="visible" class="layer-popup-container">
		<div class="layer-popup" id="layerPopupTerms">
			<div>
				<div class="popup-wrapper">
					<header class="popup-header">
						<h2 class="header-title">개인정보 수집·이용 및 제공 동의(응모)</h2>
						<button type="button" class="btn-close" @click="clickClose">
							<i class="icon-close">팝업닫기</i>
						</button>
					</header>
					<div class="popup-body">
						<p class="popup-body-desc mb1">2024년 12월 동행축제 경품 이벤트(찜하기 이벤트)를 위하여 「개인정보 보호법」에 따라 본인의 동의를 얻어야 합니다. 아래의 개인정보 수집·이용 및 제공에 관한 내용을 자세히 읽어 보신 후 동의 여부를 결정하여 주시기 바랍니다.</p>
						<div class="form-checkbox is-round is-largetext">
							<input type="checkbox" v-model="allAgree" id="check11" @change="allAgreeClick" />
							<label for="check11">모두 동의</label>
						</div>
						<!-- s: 개인정보 수집·이용 -->
						<section class="section">
							<div class="section-content section-content--large">
								<div class="terms-wrap">
									<section class="terms-section">
										<h4 class="terms-section-title">1. (필수) 12월 동행축제 경품 이벤트(찜하기 이벤트) 사업 참여를 위한 개인정보 수집·이용에 관한 사항</h4>
										<ul class="dot-list">
											<li>수집·이용 목적 : 경품 이벤트(찜하기 이벤트) 응모, 추첨, 본인확인, 문의, 안내사항 전달, 조사 및 통계, 성과 관리</li>
											<li>수집·이용 항목 : 이름, 연락처</li>
											<li>보유·이용 기간 : <strong class="strong">수집일로부터 3개월 (경품지급 완료 후 파기)</strong></li>
										</ul>

										<p>※ 동의를 거부할 권리 및 동의를 거부할 경우의 불이익 : 위 개인정보의 수집·이용에 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우 12월 동행축제 경품 이벤트(찜하기 이벤트) 참여가 불가합니다.</p>
									</section>
								</div>
							</div>
							<div class="section-header">
								<h4 class="title">
									<div class="form-checkbox is-round">
										<input type="checkbox" v-model="agree1" id="check12" @change="agreeClick" />
										<label for="check12">
											<span>위와 같이 개인정보 수집·이용에 동의합니다.</span>
										</label>
									</div>
								</h4>
							</div>
						</section>
						<!-- e: 개인정보 수집·이용 -->
						<!-- s: 14세 이상 -->
						<section class="section">
							<div class="section-content section-content--single">
								<div class="terms-wrap">
									<section class="terms-section">
										<h4 class="terms-section-title">2. (필수) 본 이벤트는 만 14세 이상 응모자만 참여가 가능합니다.</h4>
									</section>
								</div>
							</div>
							<div class="section-header">
								<h4 class="title">
									<div class="form-checkbox is-round">
										<input type="checkbox" v-model="agree2" id="check13" @change="agreeClick" />
										<label for="check13">
											<span>만 14세 이상입니다.</span>
										</label>
									</div>
								</h4>
							</div>
						</section>
						<!-- e: 14세 이상 -->
					</div>
					<div class="popup-footer">
						<div class="buttons">
							<button type="button" class="button is-medium is-secondary" @click="confirmClick">확인</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
import Icon from '@/components/common/Icon';
import { MUT_SHOW_ALERT } from '@/store/_mut_consts';
export default {
	name: 'EventTermsModal',
	props: {
		visible: Boolean,
		isLoading: false,
		noShow: false,
	},
	components: { Icon },
	data: () => ({
		allAgree: false,
		agree1: false,
		agree2: false,
		agree3: false,
	}),
	computed: {},
	watch: {},
	created() {},
	mounted() {},
	methods: {
		clickClose() {
			this.$emit('closeModal');
		},
		allAgreeClick() {
			if (this.allAgree) {
				this.agree1 = true;
				this.agree2 = true;
			} else {
				this.agree1 = false;
				this.agree2 = false;
			}
		},
		agreeClick() {
			if (this.agree1 && this.agree2) {
				this.allAgree = true;
			} else {
				this.allAgree = false;
			}
		},

		confirmClick() {
			if (this.allAgree) {
				this.$emit('agreeModal');
			} else {
				this.$store.commit(`common/${MUT_SHOW_ALERT}`, { title: `약관 동의를 체크해주세요.` });
			}
		},
	},
};
</script>
